import useChallengesTabs from './useChallengesTabs'
import useRateAndAccuracyItems from './useRateAndAccuracyItems'
import useMatchingLeraningBtn from './useMatchingLeraningBtn'
import useReportDisplayBtns from './useReportDisplayBtns'
import useViewGraphBtns from './useViewGraphBtns'
import constants from './constants'

export default { constants, useViewGraphBtns, useReportDisplayBtns, useChallengesTabs, useRateAndAccuracyItems, useMatchingLeraningBtn }